module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/Plyny-eksploatacyjne-d51274c1.svg";